module.exports = "/_next/static/images/7e29e58dce8f189891498fc70eb27716-rewards-app-xs@3x.png";